module.exports = __webpack_public_path__ + "static/media/entertain-brylcreem.5185c529.mp4";